export function limitTextarea() {
  const containers = document.querySelectorAll('.js-limit-textarea');

  if(containers.length) {
    containers.forEach(el => {
      // テキストエリアとカウンターの要素を取得
      const textarea = el.querySelector('textarea');
      const maxLength = el.getAttribute('data-max-length');

      if(textarea && maxLength) {
        const counter = el.querySelector('.js-textcounter');

        // 文字数をカウントしてカウンターを更新する関数
        function updateCounter() {
          const textLength = textarea.value.length;
          if(counter) counter.textContent = `${textLength} / ${maxLength}`;
        }

        // テキストエリアの入力イベントとペーストイベントに対する処理
        textarea.addEventListener('input', () => {
          // 文字数が最大値を超えていれば切り捨てる
          if (textarea.value.length > maxLength) {
            textarea.value = textarea.value.substr(0, maxLength);
          }
          updateCounter();
        });

        // ペーストイベントの処理
        textarea.addEventListener('paste', (e) => {
          // ペーストされた内容を取得
          const pastedText = e.clipboardData.getData('text');
          // 現在のテキストエリアの内容とペーストされた内容を結合
          const combinedText = textarea.value + pastedText;
          // 結合した内容が最大文字数を超えていれば切り捨て
          if (combinedText.length > maxLength) {
            textarea.value = combinedText.substr(0, maxLength);
            // デフォルトのペースト処理をキャンセル
            e.preventDefault();
          }
          updateCounter();
        });

        // 初期表示時のカウンター更新
        updateCounter();
      }
    })
  }
}